<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import BrokerageChildList from '@components/brokerage-console/child-list'

export default {
  page: {
    title: 'BrokerageConsole::ChildList',
    meta: [{ name: 'description', content: 'BrokerageConsole::ChildList' }],
  },
  components: { BrokerageConsoleLayout, BrokerageChildList },
}
</script>

<template>
  <BrokerageConsoleLayout>
    <BrokerageChildList></BrokerageChildList>
  </BrokerageConsoleLayout>
</template>
